import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import minusImage1 from "../../Images/minusImage1.png";
import plusImage1 from "../../Images/plusImage1.png";
import PaymentPage from "./PaymentPage";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function CheckOutDeliveryDetails({
  OBJForCheckOutDeliveryDetails,
  AcceptTerms,
  setAcceptTerms,
  setOpenCommentSection,
  OpenCommentSection,
  setOpenPromoCode,
  OpenPromoCode,
  setTheText,
  TheText,
  setPromoCode,
  PromoCode,
  setPromoCode2,
  PromoCode2,
  //PaymentPage
  setCardNumber,
  cardNumber,
  setExpirtyDate,
  ExpirtyDate,
  setCVV,
  CVV,
  setNameCardHolder,
  NameCardHolder,
  setCardType,
  cardType,
}) {
  const { t, i18n } = useTranslation();
  const [City, setCity] = useState(OBJForCheckOutDeliveryDetails.city);

  const [Street, setStreet] = useState(OBJForCheckOutDeliveryDetails.street);
  const [Building, setBuilding] = useState(
    OBJForCheckOutDeliveryDetails.building
  );
  const [Apartment, setApartment] = useState(
    OBJForCheckOutDeliveryDetails.apartment
  );
  const [ZipCode, setZipCode] = useState(OBJForCheckOutDeliveryDetails.zipCode);

  const toggleCommentSection = () => {
    setOpenCommentSection(!OpenCommentSection);
  };
  const toggleOpenPromoCode = () => {
    setOpenPromoCode(!OpenPromoCode);
  };

  const AcceptTermsFunc = (event) => {
    setAcceptTerms(event.target.checked ? 1 : 0);
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    //when do AcceptTermsFunc hide this
    setAcceptTerms(1);
    //end when do AcceptTermsFunc hide this

    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [CheckPromoCodesResponse, setCheckPromoCodesResponse] = useState(false);
  const [CheckPromoCodesErr, setCheckPromoCodesErr] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const CheckPromoCodes = async (PromoCode) => {
    setPromoCode2(null);
    const data = {
      UserId: user?.userId,
      PromoCodes: {
        Name: PromoCode,
      },
    };

    try {
      const response = await axios.post(
        `${MyDomain}PromoCodes/CheckPromoCodes`,
        data
      );

      console.log(response.data);
      setPromoCode2(response.data);
      setCheckPromoCodesResponse(false);
      setCheckPromoCodesErr("");
    } catch (err) {
      setCheckPromoCodesResponse(true);
      setCheckPromoCodesErr(err.response.data);
      console.log(err.response.data);
      //setError(err);
    } finally {
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: windowWidth <= 1024 ? "column" : "row",
        width: "100%",
        justifyContent: "space-between",
        position: "relative",
        //backgroundColor: "red",
        //paddingRight: windowWidth <= 1024 ? "0%" : "5%",
        paddingBottom: 50,
      }}
    >
      {/* <div
        style={{
          display: "flex",
          width: windowWidth <= 1024 ? "100%" : "46%",
          flexDirection: "column",
        }}
      >
        <TextField
          id="standard-basic"
          label={t("profile.City")}
          variant="standard"
          disabled
          style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
          }}
          value={City}
          onChange={(e) => setCity(e.target.value)}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#a1a1aa", // Default color for bottom line
              opacity: 0.5,
              borderBottomWidth: "1px", // Thin bottom line
            },
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#a1a1aa", // Keep it gray on hover
              opacity: 0.8,
              borderBottomWidth: "1px", // Keep it thin on hover
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#6366f1", // Change to yellow on focus
              borderBottomWidth: "1px", // Keep it thin when focused
            },
            "& .MuiInputBase-root": {
              //color: "#a1a1aa", // Color of the text in the input field
              fontSize: "14px", // Set font size of entered value to 14px
            },
          }}
        />
        <TextField
          id="standard-basic"
          label={t("profile.Street")}
          variant="standard"
          disabled
          style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
          }}
          value={Street}
          onChange={(e) => setStreet(e.target.value)}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#a1a1aa", // Default color for bottom line
              opacity: 0.5,
              borderBottomWidth: "1px", // Thin bottom line
            },
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#a1a1aa", // Keep it gray on hover
              opacity: 0.8,
              borderBottomWidth: "1px", // Keep it thin on hover
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#6366f1", // Change to yellow on focus
              borderBottomWidth: "1px", // Keep it thin when focused
            },
            "& .MuiInputBase-root": {
              //color: "#a1a1aa", // Color of the text in the input field
              fontSize: "14px", // Set font size of entered value to 14px
            },
          }}
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            id="standard-basic"
            label={t("profile.Building")}
            variant="standard"
            disabled
            style={{ paddingBottom: 30, width: "45%", fontSize: 10 }}
            InputLabelProps={{
              style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
            }}
            value={Building}
            onChange={(e) => setBuilding(e.target.value)}
            sx={{
              "& .MuiInput-underline:before": {
                borderBottomColor: "#a1a1aa", // Default color for bottom line
                opacity: 0.5,
                borderBottomWidth: "1px", // Thin bottom line
              },
              "& .MuiInput-underline:hover:before": {
                borderBottomColor: "#a1a1aa", // Keep it gray on hover
                opacity: 0.8,
                borderBottomWidth: "1px", // Keep it thin on hover
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#6366f1", // Change to yellow on focus
                borderBottomWidth: "1px", // Keep it thin when focused
              },
              "& .MuiInputBase-root": {
                //color: "#a1a1aa", // Color of the text in the input field
                fontSize: "14px", // Set font size of entered value to 14px
              },
            }}
          />
          <TextField
            id="standard-basic"
            label={t("profile.Apt")}
            variant="standard"
            disabled
            style={{ paddingBottom: 30, width: "45%", fontSize: 10 }}
            InputLabelProps={{
              style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
            }}
            value={Apartment}
            onChange={(e) => setApartment(e.target.value)}
            sx={{
              "& .MuiInput-underline:before": {
                borderBottomColor: "#a1a1aa", // Default color for bottom line
                opacity: 0.5,
                borderBottomWidth: "1px", // Thin bottom line
              },
              "& .MuiInput-underline:hover:before": {
                borderBottomColor: "#a1a1aa", // Keep it gray on hover
                opacity: 0.8,
                borderBottomWidth: "1px", // Keep it thin on hover
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#6366f1", // Change to yellow on focus
                borderBottomWidth: "1px", // Keep it thin when focused
              },
              "& .MuiInputBase-root": {
                //color: "#a1a1aa", // Color of the text in the input field
                fontSize: "14px", // Set font size of entered value to 14px
              },
            }}
          />
        </div>
        <TextField
          id="standard-basic"
          label={t("profile.ZIPCode")}
          variant="standard"
          disabled
          style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
          }}
          value={ZipCode}
          onChange={(e) => setZipCode(e.target.value)}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#a1a1aa", // Default color for bottom line
              opacity: 0.5,
              borderBottomWidth: "1px", // Thin bottom line
            },
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#a1a1aa", // Keep it gray on hover
              opacity: 0.8,
              borderBottomWidth: "1px", // Keep it thin on hover
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#6366f1", // Change to yellow on focus
              borderBottomWidth: "1px", // Keep it thin when focused
            },
            "& .MuiInputBase-root": {
              //color: "#a1a1aa", // Color of the text in the input field
              fontSize: "14px", // Set font size of entered value to 14px
            },
          }}
        />
      </div> */}
      <div
        style={{
          display: "flex",
          width: windowWidth <= 1024 ? "100%" : "46%",
          //backgroundColor: "#e4e4e7",
          flexDirection: "column",
          //height: "calc(50vh - 55px)",
          marginLeft: i18n.resolvedLanguage === "en" ? 0 : "2%",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "#6b21a8", // Uncommented and set to blue
            }}
          >
            <img
              src={OpenCommentSection ? minusImage1 : plusImage1}
              alt={OpenCommentSection ? "Collapse" : "Expand"}
              style={{
                width: 14,
                height: 14,
                cursor: "pointer",
                filter:
                  "invert(24%) sepia(59%) saturate(460%) hue-rotate(180deg)",
                marginTop: 2,
              }}
              onClick={toggleCommentSection}
            />
            &nbsp;
            <a style={{ fontSize: 14 }}>{t("profile.Addacommenttotheorder")}</a>
          </div>

          {/* TextField with smooth transition */}
          <div
            style={{
              overflow: "hidden",
              maxHeight: OpenCommentSection ? "100%" : "0", // Adjust height as needed
              opacity: OpenCommentSection ? 1 : 0,
              transition: "max-height 0.5s ease-out, opacity 0.3s ease-out",
              width: "100%",
            }}
          >
            <TextField
              id="outlined-multiline-static"
              multiline
              rows={4}
              variant="outlined"
              style={{ paddingBottom: 20, width: "100%", fontSize: 10 }}
              InputLabelProps={{
                style: { color: "#a1a1aa", fontSize: "14px" },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#a1a1aa",
                    borderRadius: 0,
                  },
                  "&:hover fieldset": {
                    borderColor: "#a1a1aa",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#a1a1aa",
                    borderWidth: 0.5,
                  },
                },
                "& .MuiInputBase-root": {
                  fontSize: "14px",
                },
              }}
              onChange={(e) => setTheText(e.target.value)}
              value={TheText}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "#6b21a8", // Uncommented and set to blue
            }}
          >
            <img
              src={OpenPromoCode ? minusImage1 : plusImage1}
              alt={OpenPromoCode ? "Collapse" : "Expand"}
              style={{
                width: 14,
                height: 14,
                cursor: "pointer",
                filter:
                  "invert(24%) sepia(59%) saturate(460%) hue-rotate(180deg)",
                marginTop: 2,
              }}
              onClick={toggleOpenPromoCode}
            />
            &nbsp;
            <a style={{ fontSize: 14 }}>
              {t("profile.Ihaveapromocodeorcertificate")}
            </a>
          </div>

          {/* TextField with smooth transition */}
          <div
            style={{
              overflow: "hidden",
              maxHeight: OpenPromoCode ? "100%" : "0", // Adjust height as needed
              opacity: OpenPromoCode ? 1 : 0,
              transition: "max-height 0.5s ease-out, opacity 0.3s ease-out",
              width: "100%",
              paddingTop: 10,
            }}
          >
            <a style={{ fontSize: 14 }}>
              {t("longTexts.InCheckOutForPromoCode")}
            </a>
            <TextField
              id="standard-basic"
              label={t("profile.Enterpromocode")}
              variant="standard"
              style={{ width: "100%", fontSize: 10 }}
              InputLabelProps={{
                style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
              }}
              value={PromoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              sx={{
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#a1a1aa", // Default color for bottom line
                  opacity: 0.5,
                  borderBottomWidth: "1px", // Thin bottom line
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottomColor: "#a1a1aa", // Keep it gray on hover
                  opacity: 0.8,
                  borderBottomWidth: "1px", // Keep it thin on hover
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "#6366f1", // Change to yellow on focus
                  borderBottomWidth: "1px", // Keep it thin when focused
                },
                "& .MuiInputBase-root": {
                  //color: "#a1a1aa", // Color of the text in the input field
                  fontSize: "14px", // Set font size of entered value to 14px
                },
              }}
            />
            {CheckPromoCodesResponse ? (
              <>
                <a style={{ fontSize: 14, color: "red" }}>
                  {CheckPromoCodesErr}
                </a>
              </>
            ) : (
              <>
                {/* {PromoCode !== "" ? (
                  <>
                    <a style={{ fontSize: 14, color: "#059669" }}>
                      Good promo code
                    </a>
                  </>
                ) : (
                  <></>
                )} */}
              </>
            )}

            <button
              style={{
                marginTop: 20,
                backgroundColor: "#27272a",
                color: "#fff",
                border: "none",
                //padding: "10px 20px",
                cursor: "pointer",
                fontSize: "16px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: 50,
              }}
              onClick={() => {
                CheckPromoCodes(PromoCode);
                //CreateCallBack();
              }}
            >
              <a style={{ fontSize: 14 }}>{t("profile.Usepromocode")}</a>
            </button>
          </div>
          {/* <a
            style={{
              display: "flex",
              margin: 0,
              justifyContent: "flex-start",
              alignItems: "flex-start",
              paddingTop: 10,
              paddingBottom: 50,
              fontSize: 14,
              width: "80%",
            }}
          >
            <Checkbox
              style={{
                paddingTop: 3,
              }}
              {...label}
              icon={
                <Box
                  sx={{
                    width: 18,
                    height: 18,
                    border: "1.4px solid black", // border for unchecked state
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 1,
                  }}
                />
              } // Unchecked icon
              checkedIcon={
                <Box
                  sx={{
                    width: 18,
                    height: 18,
                    border: "1.4px solid black", // border for checked state
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 10, // smaller square inside
                      height: 10,
                      backgroundColor: "black", // color of the small square
                    }}
                  />
                </Box>
              } // Checked icon with small square
              checked={AcceptTerms === 1}
              onChange={AcceptTermsFunc}
              sx={{
                padding: 0, // remove padding
              }}
            />
            <a
              style={{
                display: "flex",
                flexDirection: "column",
                //color: CheckAcceptTerms === true ? "red" : "black",
              }}
            >
              <a style={{ color: AcceptTerms === 1 ? "black" : "red" }}>
                {t("longTexts.acceptTerms")}
              </a>
            </a>
          </a> */}
          {AcceptTerms === 1 ? (
            <>
              <PaymentPage
                setCardNumber={setCardNumber}
                cardNumber={cardNumber}
                setExpirtyDate={setExpirtyDate}
                ExpirtyDate={ExpirtyDate}
                setCVV={setCVV}
                CVV={CVV}
                setNameCardHolder={setNameCardHolder}
                NameCardHolder={NameCardHolder}
                setCardType={setCardType}
                cardType={cardType}
                OBJForCheckOutDeliveryDetails={OBJForCheckOutDeliveryDetails}
                TheText={TheText}
                PromoCode={PromoCode}
                setPromoCode2={setPromoCode2}
                PromoCode2={PromoCode2}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
